/**
 * Date formatting utilities
 */

/**
 * Formats a date string in German locale (e.g., "30. Dezember 2025")
 */
export function formatDateDE(dateString: string | null | undefined): string | null {
  if (!dateString) return null;
  return new Intl.DateTimeFormat("de-DE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(dateString));
}
